import React, { useContext } from 'react'

import SavePublicTripItemButton from 'tripPlanner/components/Buttons/SavePublicTripItemButton'
import TripContext, { TripContextValue } from 'tripPlanner/contexts/TripContext'
import { TripItem } from 'tripPlanner/types/tripItem'

interface Props {
  item: TripItem
  className?: string
}

function SaveTripItemButton({ item, className }: Props) {
  const context = useContext<TripContextValue | null>(TripContext)

  if (!context?.isPublicTrip || !context.tripId) return null

  return (
    <SavePublicTripItemButton
      item={item}
      tripId={context.tripId}
      className={className}
    />
  )
}

export default SaveTripItemButton
